/* eslint-disable global-require */
import angular from 'angular';

import VehicleDetailController from './vehicle-detail.controller';

import DatasheetForm from './form-datasheet/datasheet-form.component';
import DeliveryForm from './form-delivery/delivery-form.component';
import HandoverForm from './form-handover/handover.component';
import LocationForm from './form-location/location-form.component';
import PricingStickerForm from './form-pricing-sticker/pricing-sticker-form.component';
import RegistrationForm from './form-registration/registration-form.component';
import RemoveAvailabilityForm from './form-remove-availability/remove-availability.component';
import AvailabilityForm from './form-availability/availability-form.component';
import FileUploadForm from './form-upload-file/upload-file.component';
import ImageUploadForm from './form-image-upload/image-upload.component';
import OnlinePlatformForm from './form-platforms/platform-forms.component';
import OfferForm from './form-offer/offer-form.component';
import PanoramicUploadForm from './form-panoramic-upload/panoramic-form.component';
import CustomTemplateForm from './form-custom-template/form-custom-template.component';
import PricingFrom from './form-pricing/form-pricing.component';
import MileageForm from './form-mileage/form-mileage.component';
import FormWrapComponent from './form-wrap/form-precheck.component';

import './vehicle-detail.style.scss';

const DEPENDENCIES = [
  DatasheetForm,
  DeliveryForm,
  HandoverForm,
  LocationForm,
  PricingStickerForm,
  RegistrationForm,
  RemoveAvailabilityForm,
  AvailabilityForm,
  FileUploadForm,
  ImageUploadForm,
  OnlinePlatformForm,
  OfferForm,
  PanoramicUploadForm,
  CustomTemplateForm,
  PricingFrom,
  MileageForm,
  FormWrapComponent,
];

export const VehicleDetailComponent = {
  selector: 'vehicleDetail',
  restrict: 'E',
  bindings: {
    exit: '&',
    vehicle: '=',
    hash: '=',
    dummyVehicle: '=',
  },
  template: '<vehicle-detail-wrapper></vehicle-detail-wrapper>',
  controller: VehicleDetailController,
};

export default angular.module('autoboard.vehicleDetail', DEPENDENCIES)
  .directive('vehicleDetailWrapper', () => ({
    templateUrl: require('./vehicle-detail.template.html'),
  }))
  .component(VehicleDetailComponent.selector, VehicleDetailComponent)
  .name;
